import { seeded } from "./options.js";
// Smooth, deterministic value noise; scoped per instance with no global RNG changes.
export function noise3D(seed = 1) {
  const random = seeded(seed),
    table = Float32Array.from({ length: 4096 }, () => random());
  const h = (x, y, z) =>
    table[((x * 73856093) ^ (y * 19349663) ^ (z * 83492791)) & 4095];
  const mix = (a, b, t) => a + (b - a) * t,
    smooth = (t) => t * t * t * (t * (t * 6 - 15) + 10);
  return (x, y, z = 0) => {
    const i = Math.floor(x),
      j = Math.floor(y),
      k = Math.floor(z),
      u = smooth(x - i),
      v = smooth(y - j),
      w = smooth(z - k);
    return mix(
      mix(
        mix(h(i, j, k), h(i + 1, j, k), u),
        mix(h(i, j + 1, k), h(i + 1, j + 1, k), u),
        v,
      ),
      mix(
        mix(h(i, j, k + 1), h(i + 1, j, k + 1), u),
        mix(h(i, j + 1, k + 1), h(i + 1, j + 1, k + 1), u),
        v,
      ),
      w,
    );
  };
}
